import { commonFunc } from "./common/_index.js";
import { homeFunc } from "./pages/_home.js";
import { cWebFunc } from "./pages/_cWeb.js";
import { affiliationStoreFunc } from "./pages/_affiliationStore.js";
import ScrollHint from 'scroll-hint';
import { validationAdd } from "./common/_validation.js";
import { selectAdd } from "./common/_select.js";

/**
 * メインルーチン
 */
window.addEventListener( 'load', function () {
  // scroll hintの発火
  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-black',
    applyToParents: true,
    i18n: {
      scrollable: 'スクロールできます'
    }
  });

  commonFunc();
  homeFunc();
  cWebFunc();
  affiliationStoreFunc();
} );

/**
 * DOM要素（セレクト部品）にvalidメソッドを追加する関数（グローバルスコープ）
 * (Ajaxでselect要素を再生成した場合用)
 */
window.validAddForSelect = function(dataElement) {
  selectAdd(dataElement);
  validationAdd(dataElement);
}
